import React from "react";
import cvData from "../../data/cv";

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const ICON_COLORS = ["color-1", "color-2", "color-3", "color-4"];
const ANIMATE_EFFECTS = ["fadeInLeft", "fadeInRight", "fadeInLeft", "fadeInRight"];

const formatMonthYear = (dateStr) => {
  const [year, month] = dateStr.split("-");
  return `${MONTHS[parseInt(month, 10) - 1]} ${year}`;
};

const formatDateRange = (startDate, endDate) => {
  const start = formatMonthYear(startDate);
  const end = endDate ? formatMonthYear(endDate) : "Present";
  return `${start} – ${end}`;
};

const formatWebsiteDisplay = (url) => url.replace(/^https?:\/\//, "");

const timelineEntries = [
  ...cvData.experience.map((entry) => ({
    key: `${entry.company}-${entry.startDate}`,
    title: entry.title,
    organization: entry.company,
    location: entry.location,
    startDate: entry.startDate,
    endDate: entry.endDate,
    highlights: entry.highlights,
    website: null,
    isVolunteer: false,
  })),
  ...cvData.volunteerExperience.map((entry) => ({
    key: `${entry.organization}-${entry.startDate}`,
    title: entry.title,
    organization: entry.organization,
    location: entry.location,
    startDate: entry.startDate,
    endDate: entry.endDate,
    highlights: entry.highlights,
    website: entry.website ?? null,
    isVolunteer: true,
  })),
];

const Experience = () => {
  return (
    <section
      className="colorlib-experience"
      data-section="experience"
      id="experience"
    >
      <div className="colorlib-narrow-content">
        <div className="row">
          <div
            className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
            data-animate-effect="fadeInLeft"
          >
            <span className="heading-meta">Experience</span>
            <h2 className="colorlib-heading animate-box">Work Experience</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="timeline-centered">
              {timelineEntries.map((entry, index) => (
                <article
                  key={entry.key}
                  className={`timeline-entry animate-box${entry.isVolunteer ? " experience-volunteer" : ""}`}
                  data-animate-effect={ANIMATE_EFFECTS[index] ?? "fadeInLeft"}
                >
                  <div className="timeline-entry-inner">
                    <div
                      className={`timeline-icon ${ICON_COLORS[index % ICON_COLORS.length]}`}
                    >
                      <i className="icon-pen2" />
                    </div>
                    <div className="timeline-label">
                      <h2 className="experience-heading">
                        {entry.organization} · {entry.location}{" "}
                        <span>
                          {formatDateRange(entry.startDate, entry.endDate)}
                        </span>
                      </h2>
                      <p className="experience-role">
                        {entry.title}
                        {entry.website ? ` · ${formatWebsiteDisplay(entry.website)}` : ""}
                      </p>
                      <ul className="experience-highlights">
                        {entry.highlights.map((highlight) => (
                          <li key={highlight}>{highlight}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </article>
              ))}
              <article
                className="timeline-entry begin animate-box"
                data-animate-effect="fadeInBottom"
              >
                <div className="timeline-entry-inner">
                  <div className="timeline-icon color-none" />
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
